module.exports = __webpack_public_path__ + "static/media/offside.b991fc10.svg";